export class SaveToCloudResponseModel {
    public cloudLink: string | null = null;
}